import type { SanityPageBuilderSection, SanityPageBuilderTwoColumnMediaSection } from "@ouster/shared";
import { TwoColumnMediaBlockView } from "~/features/blocks/inventory/two-column-media";
import { hasRenderableSanityMedia, SanityMediaFigure } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderTwoColumnMediaSection;
  };
};
export function SanityTwoColumnMediaSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const columns = sectionContent.medias?.filter(column => hasRenderableSanityMedia(column.media)).map(column => <SanityMediaFigure fit="cover" media={column.media} sizes="lg:50vw" />) ?? [];
  return <TwoColumnMediaBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} columns={columns} hasTopDivider={sectionSettings?.hasTopDivider ?? true} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}